import { api } from '../../../services/api';

export class CreatorWorkspaceService {
  constructor() {
    this.Api = api;
  }

  getCategory(publisherId, params) {
    // return api.get(`/api/v2/publishers/${publisherId}//`, params);
  }

  getCategories(publisherId, params) {
    // return api.get(`/api/v2/publishers/${publisherId}//`, params);
  }

  getMockCategories() {
    return [
      {
        category_id: 1,
        name: 'Beauty',
        creators: '321',
        active_modules: '4',
        last_updated: '2021-08-20',
      },
      {
        category_id: 2,
        name: 'Fashion',
        creators: '321',
        active_modules: '4',
        last_updated: '2021-08-21',
      },
      {
        category_id: 3,
        name: 'Lifestyle',
        creators: '321',
        active_modules: '4',
        last_updated: '2021-08-22',
      },
      {
        category_id: 4,
        name: 'Consumer Electronics',
        creators: '321',
        active_modules: '4',
        last_updated: '2021-08-23',
      },
      {
        category_id: 5,
        name: 'Home',
        creators: '321',
        active_modules: '4',
        last_updated: '2021-08-24',
      },
    ];
  }

  getMockCategory() {
    return {
      name: 'Beauty',
      creators: 160,
      modules: [
        {
          rank: 1,
          module_type: '1 Trending Offers',
          module_title: 'Trending Offers',
          impressions: 111,
          clicks: 222,
          last_updated: '2021-08-24',
          status: 'Live',
          is_default: true,
        },
        {
          rank: 2,
          module_type: '2 abc',
          module_title: 'ABC',
          impressions: 123,
          clicks: 456,
          last_updated: '2021-08-24',
          status: 'Live',
        },
        {
          rank: 3,
          module_type: '3 def',
          module_title: 'DEF',
          impressions: 789,
          clicks: 101112,
          last_updated: '2021-08-24',
          status: 'Live',
        },
        {
          rank: 4,
          module_type: '4 def',
          module_title: 'DEF',
          impressions: 789,
          clicks: 101112,
          last_updated: '2021-08-24',
          status: 'Live',
        },
        {
          rank: 5,
          module_type: '5 def',
          module_title: 'DEF',
          impressions: 789,
          clicks: 101112,
          last_updated: '2021-08-24',
          status: 'Live',
        },
        {
          rank: 6,
          module_type: '6 def',
          module_title: 'DEF',
          impressions: 789,
          clicks: 101112,
          last_updated: '2021-08-24',
          status: 'Live',
        },
      ],
    };
  }
}

export const creatorWorkspaceService = new CreatorWorkspaceService();
